import { Type, Injectable, Inject } from '@angular/core';
import { WachterUserExt } from '../models/wachter-user.model';
import { AppMetaDataItemNames, AppMetaDataService, RoAllSupervisorsSubordinatesEntity } from '../../meta-data/app-meta-data.service';
// tslint:disable-next-line: max-line-length
import { DwAttributeType, DwContextDefinition, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwQueryMdAttribute, DwSecurityTopics, DwSecurityUserService, DwOrmDataServiceToken, DwOrmDataService, DwCacheService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


export const ethosUserSubordinatesContext = 'ethosUserSubordinatesContext'
@DwCustomContextDefinition({
    keyName: ethosUserSubordinatesContext,
    display: 'Ethos User Subordinates',
    isGlobal: true,
})
@Injectable()
export class CurrentEthosUserSubordinatesContextDefService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        @Inject(DwOrmDataServiceToken) private dwOrmDataSerice: DwOrmDataService,
        private dwCacheService: DwCacheService
        ) {
        super();
    }

    setupContextDefinition(userContextDef: DwContextDefinition) {
        userContextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];

        userContextDef.getCustomContextFunction = (context: any, contextData: any) => {

            const user = this.dwSecurityUserService.securityContext.ApplicationUser;

            let ethosUserId = null;
            if (user) {
                const wachterUser = new WachterUserExt(user);
                ethosUserId = wachterUser.trustUserId;
            }

            if (ethosUserId) { // Return a cached context
                const attrs = userContextDef.attributes;
                return this.getUserSubordinates(ethosUserId);
            }
            else
                return { // Return a dummy context
                    UserId: -1,
                    Subordinates: []
                }
        }
        userContextDef.data = {};

        userContextDef.attributes = [];
        this.addProperty(userContextDef.attributes, 'UserId', 'User Id', DwAttributeType.Integer, DwControlType.NumericTextBox);

        var hasPermissionAttr: DwExpressionAttribute = this.addProperty(userContextDef.attributes, 'Subordinates', 'Is a Subordinate', 
                                                                        DwAttributeType.Integer, DwControlType.NumericTextBox);
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, 
                                          DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
    }

    private getUserSubordinates(ethosUserId: number): Observable<EthosUserSubordinates> {
        const key = `userSubordinates_${ethosUserId}`;
        return this.dwCacheService.get(key, this.loadUserSubordinates(ethosUserId));
    }

    private loadUserSubordinates(ethosUserId: number): Observable<EthosUserSubordinates> {
        const query = new DwQuery(AppMetaDataItemNames.RoAllSupervisorsSubordinates);

        const md = new AppMetaDataService();
        const qh = new DwQueryHelper();

        query.AddFields([md.RoAllSupervisorsSubordinates.UserId]);
        query.AddFilterAnd(qh.filters.Equal(md.RoAllSupervisorsSubordinates.SupervisorUserId, ethosUserId));

        // Return 4000 records - its a ton, but Brian Sloan has 3028 active employees assigned to him
        query.SetupPaging(1, 1000000, false);
        
        return this.dwOrmDataSerice.executeQuery(query)
            .pipe(map((users: RoAllSupervisorsSubordinatesEntity[]) => {
                const userSubordinates: EthosUserSubordinates = {
                    UserId : ethosUserId,
                    Subordinates: users.map(u => u.UserId) || []
                };
                return userSubordinates;
            }));
    }
}


export interface EthosUserSubordinates {
    UserId: number;
    Subordinates: number[];
}